import BannerImage from './components/BannerImage';
import AlbumMaker from './components/AlbumMaker';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <BannerImage />
        <div>
          <h1>From Burned Out to Board</h1>
          <h3>Melifluous Mat</h3>
          <AlbumMaker/>
        </div>
      
      </header>
    </div>
  );
}

export default App;
